module.exports = new __parcel__URL__("tokenary.adefe59c.svg").toString();